import { withApp } from "@/components/App"
import Edit from "@/onboarding/features/component_library/components/Edit"

export default withApp(Edit)
